import { Controller } from "@hotwired/stimulus"

// L'editor di una riga di fattura (Riga di components/rendicontazione/RigheVoci.js, 31a5bd1): «Scegli voce» aggiunge una
// voce (con l'importo dell'operatore solo quando le voci sono piu' d'una), «Estranea al progetto» chiede il motivo,
// «Conferma» compare con almeno una voce o con la riga estranea; la proposta gialla si conferma da sola (con la nota
// sul fornitore scritta). L'invio e' del form (PUT …/righe): le voci vanno come voci[][voce_id] e voci[][importo].
export default class extends Controller {
  static targets = ["righe", "modello", "motivo", "estranea", "conferma", "proposte"]

  aggiungi() {
    this.setEstranea(false)
    this.righeTarget.append(this.modelloTarget.content.cloneNode(true))
    this.aggiorna()
  }

  estranea() {
    this.righeTarget.replaceChildren()
    this.setEstranea(true)
    this.aggiorna()
  }

  togli({ currentTarget }) {
    currentTarget.closest("[data-riga]").remove()
    this.aggiorna()
  }

  cambia() { this.aggiorna() }

  conferma({ params: { voce } }) {
    this.setEstranea(false)
    this.righeTarget.replaceChildren(this.modelloTarget.content.cloneNode(true))
    this.righeTarget.querySelector("select").value = voce
    this.aggiorna()
    this.element.requestSubmit()
  }

  setEstranea(si) {
    this.estraneaTarget.value = String(si)
    this.motivoTarget.hidden = !si
    this.motivoTarget.disabled = !si
    if (si) this.motivoTarget.focus()
  }

  // le proposte si nascondono con le voci scelte (righe.length === 0 nell'originale); l'importo solo con piu' voci
  aggiorna() {
    const righe = Array.from(this.righeTarget.querySelectorAll("[data-riga]"))
    righe.forEach((r) => {
      const importo = r.querySelector("[data-importo]")
      importo.hidden = righe.length < 2
      importo.disabled = righe.length < 2
    })
    if (this.hasProposteTarget) this.proposteTarget.hidden = righe.length > 0
    this.confermaTarget.hidden = !(righe.length > 0 || this.estraneaTarget.value === "true")
  }
}
